import { applyMiddleware, compose, createStore, Middleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { Json } from '../types/types';
import { setActionTypes } from '../utils/globals';
import { generateActionsForStore } from './actions';
import { generateActionTypesDictionaryForStore } from './actionTypes';
import { generateReducerForStore } from './reducers';

const sagaMiddleware = createSagaMiddleware();

export const generateStore = <T extends Json>(
  initialState: T,
  middlewares: Middleware[] = [],
  rootSaga?: any
) => {
  const actions = generateActionsForStore<T>(initialState);

  const rootReducer = generateReducerForStore<T>(initialState);
  // const rootReducer = combineReducers(reducers);

  const allMiddlewares = [sagaMiddleware, ...middlewares];
  const middlewareEnhancer = applyMiddleware(...allMiddlewares);

  const composedEnhancers = compose(middlewareEnhancer);

  const actionTypes = generateActionTypesDictionaryForStore<T>(initialState);
  setActionTypes(actionTypes);

  const store = createStore(rootReducer, { ...initialState }, composedEnhancers) as any;

  if (rootSaga) {
    sagaMiddleware.run(rootSaga);
  }

  return { store, actions };
};
